import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useHostStore } from "host/HostStore";
import Cookies from "js-cookie";

import { textConstants } from "../../../constants/textConstants";
import { endpoints } from "../../../endpoints";

export const TokenVerification = () => {
    const navigate = useNavigate();
    const { auth, setAuth } = useHostStore();

    const setHostAuthenticationState = () => {
        let updatedAuth = null;

        if (!auth) {
            updatedAuth = { isLoggedIn: true };
        } else {
            updatedAuth = { ...auth, isLoggedIn: true };
        }
        setAuth(updatedAuth);
    };

    useEffect(() => {
        Cookies.remove("system_token");
        (async () => {
            const hash = location.hash.substring(1);
            if (hash.includes("access_token")) {
                let accessToken;
                // find access code
                const hashArray = hash.split("&");
                hashArray.forEach((element) => {
                    const params = element.split("=");
                    if (params[0] === "access_token") {
                        accessToken = params[1];
                    }
                });
                // api call to validate access code
                const response2 = await fetch(endpoints.loginWithIdpToken, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        Accept: "application.json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                const data = await response2.json();
                localStorage.setItem("userDetails", data.user_id);
                // localStorage.setItem("USER_ID", response2);
                // redirect to next sub system
                if (response2.status === 200) {
                    localStorage.setItem("system_token", Cookies.get("system_token") as string);
                    setHostAuthenticationState();
                    navigate("/on-boarding");
                }
            }
        })();
    }, []);
    return (
        <div className="flex h-screen justify-center items-center flex-col">
            <h1 className="text-xl">{textConstants.VERIFY_AND_REDIRECT}</h1>
        </div>
    );
};
